import ICON__download_solid from '@/assets/icons/font_awesome/download-solid.svg?react';
import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { PLACEHOLDER_BUTTON__bar } from '@/pages/_base/buttons/PLACEHOLDER_BUTTON__bar';
import { FIELD__image_asset } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_asset';
import { FN_IMAGE__download } from './FN_IMAGE__download';

interface PROPS {
  field: FIELD__image_asset;
}

export function G_GRAPH__BUTTON__image_download({ field }: PROPS) {
  /*
   * STORE
   */
  /*
   * STATE
   */

  /*
   * EVENTS
   */
  async function onClick(e: React.MouseEvent) {
    e.stopPropagation();

    let promises = [];

    let fields = field.fields__get_by_type(FIELD__image_asset);
    fields = fields.filter(field => !field.is_stub()); //skip stubs
    fields = fields.filter(field => field.image__is_initialized); //keep initialized

    if (field instanceof FIELD__image_asset) fields.push(field);

    for (let field of fields) {
      promises.push(FN_IMAGE__download(field.asset.url_relative, field.asset.hash_sha256_content.remove_string_protocol()));
    }

    await Promise.all(promises);
  }

  /*
   * METHODS
   */

  /*
   * HTML
   */

  if (field.meta.data__is_linked) return <PLACEHOLDER_BUTTON__bar class_name_button="size-6" />;
  if (!field.image__is_initialized) return <PLACEHOLDER_BUTTON__bar class_name_button="size-6" />;
  if (field.asset.is_single_color) return <PLACEHOLDER_BUTTON__bar class_name_button="size-6" />;

  return (
    <UI_PRIMITIVE__button size={'square-6'} variant={'no-border-on-bar'} {...{ onClick }}>
      <ICON__download_solid className="!size-3" />
    </UI_PRIMITIVE__button>
  );
}
